import { Backdrop, Box, CircularProgress } from '@mui/material';
import Fade from '@mui/material/Fade';
import React from 'react';

/**
 * Largeurs de la sidebar de la BRL (`Layout/Sidebar/Sidebar.scss`). Le backdrop couvre tout
 * l'écran, sidebar comprise : sans décalage, son contenu est centré sur la fenêtre et non sur
 * la zone de contenu. Décaler de la largeur de la sidebar recentre exactement sur celle-ci.
 * La BRL bascule `sidebar-collapsed` / `sidebar-expanded` sur `document.body`.
 */
const EXPANDED_SIDEBAR_WIDTH = '280px';
const COLLAPSED_SIDEBAR_WIDTH = '52px';

const BackdropWithLoader = ({
  onClose,
  message,
  open
}: {
  onClose?: () => void;
  message: string;
  open: boolean;
}) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontSize: '1.2rem'
      }}
      open={open}
      TransitionComponent={Fade}
      transitionDuration={{ enter: 300, exit: 500 }}
      onClick={onClose}
    >
      <Box
        className="d-flex flex-column align-items-center"
        sx={{
          marginLeft: EXPANDED_SIDEBAR_WIDTH,
          'body.sidebar-collapsed &': { marginLeft: COLLAPSED_SIDEBAR_WIDTH }
        }}
      >
        <CircularProgress color="inherit" sx={{ mb: 2 }} />
        {message}
      </Box>
    </Backdrop>
  );
};

export default BackdropWithLoader;
